// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartTotalStyles } from "@guestsupply/Overrides/Widgets/Cart/CartTotal";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, get } from "@insite/mobius/utilities";
import { css } from "styled-components";
// OOTB Styles
cartTotalStyles.checkoutButton = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-top: 16px;
                        width: 100%;
                        z-index: ${get(theme, "zIndex.stickyFooter")};
                    `,
                    css`
                        width: 100%;
                        margin-top: 16px;
                        position: inherit;
                        left: inherit;
                        bottom: inherit;
                    `,
                ],
                "min",
            )}
    `,
};
cartTotalStyles.cancelPunchOutButton = {
    buttonType: "outline",
    variant: "tertiary",
    css: css`
        width: 100%;
        margin-top: 12px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};
cartTotalStyles.submitQuoteButton = {
    buttonType: "outline",
    variant: "tertiary",
    css: css`
        width: 100%;
        margin-top: 12px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};
cartTotalStyles.saveOrderButton = {
    buttonType: "outline",
    variant: "tertiary",
    css: css`
        width: 100%;
        margin-top: 12px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};
cartTotalStyles.submitRequisitionButton = {
    css: css`
        width: 100%;
        margin-top: 12px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};
cartTotalStyles.totalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};
cartTotalStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;

         ${xScreen("lte", "xs")} {
            button {
                width: 100%;
            }
        }
    `,
};
cartTotalStyles.closeButton = {
    css: css`
        margin-right: 10px;

        ${xScreen("lte", "xs")} {
            margin-right: 0;
            margin-bottom: 10px;
        }
    `,
};